import React from 'react'
import CategoryVarietyCard from '../components/Cards/CategoryVarietyCard'
import Footer from '../components/layout/Footer'
import Navbar from './Navbar'
const ShopByCategory = () => {
  return (
    <div>
      <Navbar/>
  <div className='py-4 md:px-16 lg:px-32 border bg-gray-200 border-gray-400'>
        <div>
          <CategoryVarietyCard Image={'/images/Groccery/Grocceries.png'}/>
          <CategoryVarietyCard Image={'/images/Homekitchen.png'}/>
          <CategoryVarietyCard Image={'/images/Fashoin.png'}/>
          <CategoryVarietyCard Image={'/images/Electronics.png'}/>
          <CategoryVarietyCard Image={'/images/Beauty.png'}/>
          <CategoryVarietyCard Image={'/images/Jewellery.png'}/>
        </div>
    </div>
    <Footer/>
    </div>
  
  )
}

export default ShopByCategory